const validateFio = (value: string): boolean => /^[А-ЯЁа-яё' -]+$/.test(value);
const validateGender = (value: string): boolean => /^[M,W,N]*$/.test(value);
const validateAgeValueBetween = (value: string, vm: any) => {
  const { ageFrom } = vm;
  return ageFrom.length && value.length
    ? parseInt(ageFrom, 10) < parseInt(value, 10)
    : true;
};
const fioFormatter = (text: string) => {
  if (!text.length) {
    return text;
  } else if (text.length === 1) {
    return text.toUpperCase();
  } else {
    return text
      .split(/ +/g)
      .map((el) => {
        if (!el.length) {
          return el;
        } else if (el.length === 1) {
          return el.toUpperCase();
        } else {
          return el[0].toUpperCase() + el.substring(1);
        }
      })
      .join(' ');
  }
};
const fioRegex = '[А-Яа-я ё]+';
const noFirstLastMultipleWhiteSpace = (value: string): boolean => {
  if (!value?.length) return true;
  return /^\S((?!.* {2,}).*\S)?$/.test(value);
};

export {
  validateFio,
  validateGender,
  validateAgeValueBetween,
  fioFormatter,
  fioRegex,
  noFirstLastMultipleWhiteSpace,
};



// WEBPACK FOOTER //
// ./src/tools/validators/validatefio.ts